<!-- =========================================================================================
  File Name: BreaksCreate.vue
  Description: Breaks Create Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div v-if="breaksCreatePermission" id="page-user-edit">
		<vx-card>
			<break-tab class="mt-4" />
		</vx-card>
	</div>
	<not-permission v-else></not-permission>
</template>

<script>
import NotPermission from "@/views/pages/NotPermission.vue";
import BreakTab from "./BreakTab.vue";

export default {
	components: {
		NotPermission,
		BreakTab,
	},
	computed: {
		breaksCreatePermission() {
			return this.$store.getters.checkPermission("BREAKS_C");
		},
	},
};
</script>

<style lang="scss" scoped>
#page-user-edit {
	height: 30%;
}
</style>
